<template>
  <div class="fd_body" v-if="body_show">
    <!-- 公用头部 -->
    <public-header></public-header>
    <div class="men_informe">
      <img :src="teacher.picture" />
      <h2>{{teacher.name}}</h2>
      <h3>{{teacher.honor}}</h3>
      <ul class="clearfix">
        <li>
          <h4>咨询量</h4>
          <h5>{{count}}人</h5>
        </li>
        <li>
          <h4>辅导满意度</h4>
          <h5>{{satisfaction}}分</h5>
        </li>
        <li>
          <h4>问题解决度</h4>
          <h5>{{solves}}分</h5>
        </li>
      </ul>
    </div>
    <div class="men_informain">
      <h1>擅长职位</h1>
      <h2>
          <span v-for="item in teacher.position">{{item}}</span>
        </h2>
    </div>
    <div class="men_informain">
      <h1>个人简介</h1>
      <p>{{teacher.introduction}}</p>
    </div>
    <div class="men_informain" v-if="feedback.length>0">
      <h1>客户评价</h1>
      <div class="men_pj" v-for="(item,index) in feedback">
        <div class="informain_top clearfix">
          <img :src="item.headimgurl" />
          <div class="infor_r">
            <h3>{{item.name}}<span>辅导满意度：{{item.satisfaction}}分</span><i></i><span class="spr">问题解决度：{{item.solve}}分</span></h3>
            <h4>{{item.ctime}}</h4>
          </div>
        </div>
        <p class="pj_p" :class="{pj_hidden: (item.remark.length>52) && pj_show != index}">{{item.remark}}</p>
        <div class="close_pj" v-show="(item.remark.length>52) && pj_show != index" @click="pj_click(index)"></div>
      </div>
      <router-link :to="{path:'mentor_evaluation',query:{'teacherid':teacherid}}" class="pj_href">查看全部评价</router-link>
    </div>
    <div class="men_time">
      本周可预约量剩余<span>{{teacertimecount}}个</span>时间段
    </div>
    <div class="men_foot">
      <div class="men_fl" @click="pop_show = true">
        <img src="https://themes-cdn.xjy.cn/statics/career/images/share_ic.png" />推荐
      </div>
      <div class="men_fr" @click="assistant_show=true" v-if="teacertimecount>0">
        ¥699预约
      </div>
      <div class="men_fr" style="background: #ccc;" v-else>
        ¥699预约
      </div>
    </div>
    <div class="pop_img" v-show="pop_show" @click="pop_show = false"></div>
    <van-popup v-model="assistant_show" class="pop_assistant">
      <div class="pop_assistant_box">
        <h3 style="font-weight: bold">预约步骤</h3>
        <h4>第一步：客户下订单</h4>
        <h4>第二步：提交个人信息</h4>
        <h4>第三步：完成专业测评</h4>
        <h4>第四步：选择导师时间</h4>
        <a class="tas_href" @click="signHandle">立即预约</a>
      </div>
    </van-popup>
    <!-- 验证手机号和付款 -->
    <public-mobile ref="handle" :teacherid="teacherid" :type="'coach'"></public-mobile>
  </div>
</template>
<script>
import {
  teacherdetail
} from "@/api/totoring"
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        body_show: false,
        teacher: {},
        count: "",
        satisfaction: "",
        solves: "",
        feedback: {},
        teacherid: "",
        teacertimecount: "",
        pop_show: false,
        assistant_show: false,
        tel: false
      }
    },
    methods: {
      pullData() {
        this.teacherid = this.$route.query.teacherid
        teacherdetail({
            teacherid: this.$route.query.teacherid
          })
          .then((data) => {
            shareCon("totoring", this);
            this.body_show = true;
            this.teacher = data.teacher;
            this.count = data.count;
            this.satisfaction = data.satisfaction;
            this.solves = data.solves;
            this.feedback = data.feedback;
            this.teacertimecount = data.teacertimecount;
            this.tel = data.tel;
          })
      },
      // 立即报名
      signHandle() {
        this.pop_show = false
        if (!this.tel) {
          // 是否需要验证验证码
          this.$refs.handle.need_verify = true;
          // 判断用户手机号是否已验证
          this.$refs.handle.show = true;
        } else {
          this.$refs.handle.pay_tor()
        }
      },
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.fd_body {
  padding-bottom: changeRem(1.96)+px
}

.men_informe {
  background: #fff;
  padding: changeRem(.6)+px 0;
  text-align: center;
  margin: 0 auto;
  img {
    width: changeRem(2.4)+px;
    height: changeRem(2.4)+px;
    border-radius: 50%;
  }
  h2 {
    color: #333;
    font-size: changeRem(.68)+px;
    margin-top: changeRem(.4)+px;
    font-weight: bold;
    line-height: changeRem(.9)+px;
  }
  h3 {
    color: #333;
    font-size: changeRem(.48)+px;
    margin-top: changeRem(.22)+px;
    padding: 0 changeRem(.6)+px;
    line-height: changeRem(.8)+px;
  }
  ul {
    margin-top: changeRem(.6)+px;
    padding: 0 changeRem(.96)+px;
    li {
      float: left;
      margin: 0 changeRem(.9)+px;
      width: changeRem(2.52)+px;
      height: changeRem(1.52)+px;
      border: 2px solid rgba(204, 204, 204, 1);
      border-radius: changeRem(.16)+px;
      text-align: center;
      padding-top: changeRem(.1)+px;
      h4 {
        font-size: changeRem(.4)+px;
        color: rgba(153, 153, 153, 1);
        line-height: changeRem(.6)+px;
      }
      h5 {
        font-size: changeRem(.56)+px;
        color: #EB5032;
        line-height: changeRem(.6)+px;
      }
    }
  }
}

.men_informain {
  width: 100%;
  background: rgba(255, 255, 255, 1);
  padding: changeRem(.6)+px;
  margin-top: changeRem(.4)+px;
  h1 {
    font-size: changeRem(.68)+px;
    color: #333;
    padding-bottom: changeRem(.4)+px;
    border-bottom: 2px solid #ccc;
    text-align: left;
  }
  h2 {
    width: 100%;
    text-align: left;
    vertical-align: middle;
    span {
      margin-top: changeRem(.4)+px;
      display: inline-block;
      width: auto;
      padding: 0 changeRem(.4)+px;
      height: changeRem(1)+px;
      line-height: changeRem(1)+px;
      background: rgba(240, 240, 240, 1);
      border-radius: 2px;
      margin-right: changeRem(.4)+px;
      font-size: changeRem(.56)+px;
      color: #333;
    }
  }
  p {
    font-size: changeRem(.52)+px;
    color: #333;
    line-height: changeRem(.8)+px;
    text-align: justify;
    margin-top: changeRem(.4)+px;
    word-wrap: break-word;
  }
  .pj_p {
    color: #666;
  }
  .men_pj {
    width: 100%;
    padding-bottom: changeRem(.6)+px;
    border-bottom: 2px solid #ccc;
  }
  .informain_top {
    width: 100%;
    margin-top: changeRem(.6)+px;
    img {
      width: changeRem(1.2)+px;
      height: changeRem(1.2)+px;
      border-radius: 50%;
      float: left;
    }
    .infor_r {
      width: changeRem(12)+px;
      float: right;
      text-align: left;
      padding-top: changeRem(.1)+px;
      h3 {
        font-size: changeRem(.52)+px;
        color: #333;
        span {
          font-size: changeRem(.52)+px;
          color: #F57F17;
          margin-left: changeRem(.5)+px;
          vertical-align: middle;
        }
        .spr {
          margin-left: 0
        }
        i {
          width: 2px;
          height: changeRem(.5)+px;
          vertical-align: middle;
          display: inline-block;
          margin: 0 changeRem(.4)+px;
        }
      }
      h4 {
        font-size: changeRem(.4)+px;
        color: #999;
        margin-top: changeRem(.2)+px;
      }
    }
  }
}

.close_pj {
  margin: 0 auto;
  margin-top: changeRem(.4)+px;
  width: changeRem(.88)+px;
  height: changeRem(.6)+px;
  background: url(../../../assets/down_l.png) no-repeat top center;
  background-size: cover;
}

a.pj_href {
  width: changeRem(6.16)+px;
  height: changeRem(1.08)+px;
  background: rgba(255, 255, 255, 1);
  border: 2px solid rgba(235, 80, 50, 1);
  border-radius: changeRem(.16)+px;
  margin: 0 auto;
  margin-top: changeRem(.72)+px;
  font-size: changeRem(.52)+px;
  color: #EB5032;
  text-align: center;
  line-height: changeRem(1.08)+px;
  display: block;
}

.men_time {
  width: 100%;
  height: changeRem(3.2)+px;
  line-height: changeRem(3.2)+px;
  text-align: center;
  font-size: changeRem(.68)+px;
  background: rgba(255, 255, 255, 1);
  margin-top: changeRem(.4)+px;
  span {
    color: #F57F17;
  }
}

.men_foot {
  width: 100%;
  height: changeRem(1.96)+px;
  line-height: changeRem(1.96)+px;
  border-top: 2px solid #ccc;
  position: fixed;
  bottom: 0;
  left: 0;
  max-width: 750px;
  text-align: center;
  background: #fff;
  .men_fl {
    width: changeRem(3.6)+px;
    float: left;
    color: #F58526;
    font-size: changeRem(.52)+px;
    img {
      width: changeRem(.56)+px;
      height: changeRem(.56)+px;
      margin-right: changeRem(.24)+px;
      vertical-align: text-top;
    }
  }
  .men_fr {
    width: changeRem(11.4)+px;
    float: right;
    color: #fff;
    font-size: changeRem(.68)+px;
    background: #EB5032;
  }
}

.pop_img {
  width: 100%;
  height: 100%;
  z-index: 100001;
  position: fixed;
  top: 0;
  left: 0;
  background: url(../../../assets/popse.png) no-repeat top center;
  background-size: cover;
}


/*弹窗带二维码的*/

.pop_assistant {
  text-align: center;
  background-color: transparent;
  .pop_assistant_box {
    width: 600px;
    border-radius: 8px;
    background-color: #fff;
    padding: 10px 85px 26px;
    img {
      width: 434px;
      height: 434px;
    }
    h3 {
      margin-top: 44px;
      color: #EB5032;
      font-size: changeRem(.68)+px;
      line-height: 50px;
      margin-bottom: changeRem(.72)+px;
    }
    h4 {
      margin-top: 10px;
      color: #333;
      font-size: changeRem(.56)+px;
      line-height: changeRem(1.1)+px;
    }
    a.tas_href {
      display: block;
      margin: 0 auto;
      margin-top: changeRem(1.4)+px;
      width: changeRem(7.7)+px;
      height: changeRem(1.6)+px;
      line-height: changeRem(1.6)+px;
      background: rgba(235, 80, 50, 1);
      border-radius: changeRem(.16)+px;
      color: #fff;
      font-size: changeRem(.68)+px;
    }
  }
}
</style>
